import UsuarioService from "@/services/UsuarioService";

export const usuario = {
  namespaced: true,
  state: {
    usuario: {},
  },
  actions: {
    getUsuario({ commit }, payload) {
      return UsuarioService.GetUsuario(payload).then(
        (usuario) => {
          return Promise.resolve(usuario);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postUsuario({ commit }, payload) {
      return UsuarioService.PostUsuario(payload).then(
        (usuario) => {
          return Promise.resolve(usuario);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putUsuario({ commit }, payload) {
      return UsuarioService.PutUsuario(payload).then(
        (usuario) => {
          return Promise.resolve(usuario);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteUsuario({ commit }, payload) {
      return UsuarioService.DeleteUsuario(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getUsuarioOData({ commit }, payload) {
      return UsuarioService.GetUsuarioOData(payload).then(
        (usuario) => {
          return Promise.resolve(usuario);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    putRedefinirSenhaUsuario({ commit }, payload) {
      return UsuarioService.PutRedefinirSenhaUsuario(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putAlterarSenhaUsuario({ commit }, payload) {
      return UsuarioService.PutAlterarSenhaUsuario(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putAlterarEmailUsuario({ commit }, payload) {
      return UsuarioService.PutAlterarEmailUsuario(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getByUsuarioExists({ commit }, payload) {
      return UsuarioService.GetByUsuarioExists(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default usuario;
